import { createI18n } from "vue-i18n";

import nl from "./languages/nl";
import de from "./languages/de";
import en from "./languages/en";
import ja from "./languages/ja";
import fr from "./languages/fr";
import es from "./languages/es";
import it from "./languages/it";

export const baseMessages = {
    nl,
    de,
    en,
    ja,
    fr,
    es,
    it
};

export const i18n = createI18n({
    locale: "nl",
    messages: baseMessages
});
